<template>
  <div class="greeter" v-if="profile">
    <img class="avatar" src="@/assets/avatar.jpg" alt="Kevin" />
    <div class="name">{{this.$store.getters.fullName || ""}}</div>
    <div class="blurb">{{this.$store.state.profile.about || ""}}</div>
    <nav class="menu">
      <a v-for="contact in profile.contact" :key="contact.id" :href="contact.value">
        <fa :alt="contact.name" v-if="contact.icon==='envelope-open'" :icon="['far', 'envelope-open']" />
        <fa :alt="contact.name" v-else-if="contact.icon==='folder'" :icon="['far', 'folder']" @click="showPortfolio" />
        <fa :alt="contact.name" v-else :icon="contact.icon" />
      </a>
    </nav>
    <div class="portfolio" v-bind:class="{'active':isPortfolioVisible}">
      <div class="project" v-for="project in profile.sections.portfolio" :key="project.id">
        <a :href="project.url" target="_new">
          <div class="project-image" :style="`background-image: URL(` + project.demo + `);`"> </div>
        </a>
        <div class="project-body">
           <div class="project-header">
            <a :href="project.url" target="_new">{{ project.name }}</a>
          </div>
          <div class="project-desc">
            {{ project.desc }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Greet",
  computed: {
    profile: function() {
      return this.$store.getters.profile;
    }
  },
  data () {
    return {
      isPortfolioVisible: false
    }
  },
  methods: {
    showPortfolio: function() {
      this.isPortfolioVisible = true
    }
  }, 
  mounted: function () {
    setTimeout(() => {
      this.isPortfolioVisible = true
    }, 2000);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.greeter {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.avatar {
  border-radius: 50%;
  max-width: 128px;
}

.name {
  text-transform: uppercase;
  font-weight: 600;
  margin: 0.25rem 0;
  font-size: 1rem;
}

.blurb {
  font-size: 1rem;
  margin: 0 0 1rem 0;
}

.menu {
  border-top: 1px solid #999;
  padding: 0.8rem;
}

.svg-inline--fa {
  font-size: 2rem;
  color: #000;
  margin: 0 0.25rem;
}

.portfolio {
  height: 0;
  visibility: hidden;
  opacity: 0;
  transition: visibility .7s, opacity .7s linear;
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: hidden;

  &.active {
    height: fit-content;
    visibility: visible;
    opacity: 1;
  }

  .project {
    display: flex;

    &-image {
      height: 3rem;
      width: 3rem;
      background-size: contain;
      display: inline-flex;
      margin: 1rem;
      background-repeat: no-repeat;
      border-radius: 50%;
    }

    &-header {
      display: flex;
      font-weight: 700;
      width: 100%;
      color: rgb(37, 155, 255);
    }

    &-desc{
      display: flex;
      padding: .5rem 0;
      text-align: left;
      width: 100%;
    }

    &-body{
      align-items: center;
      justify-content: center;
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
